import React from 'react';
import Input from './Input';

export default class Textarea extends Input {
  render() {
    let baseClass = '';
    if (this.props.large) {
      baseClass = 'textarea--large';
    }

    return (
      <div className="form__group" data-required={this.props.required}>
        { this.props.label ? <label className={this.getLabelClass()}><strong>{this.props.label}</strong></label> : null }
        {
          this.props.helpText ?
          <small className="form__help-text">{this.props.helpText}</small> : null
        }
        <textarea className={baseClass} {...this.props} onBlur={this.onBlur} onChange={this.onChange}>
          {this.props.children}
        </textarea>
        {
          this.props.required && (this.state.hasBlurred && !this.state.valid) ?
          <label className="form__error-label">{this.props.invalidMsg}</label> : null
        }
      </div>
    );
  }
}
